import { ThumbDown, ThumbUp } from "@mui/icons-material";
import { Stack } from "@mui/material";
import { SubtypeToolboxPlaceholderScaffold } from "../../../pages/actionModules/ActionModuleEditor/SubtypeEditor/SubtypeToolbox";
import { SubtypeDefinition } from "../actionModule";
import { Subtype } from "./subtype";
import EvaluationThumbsSubtypeDetails from "../../../pages/incentivation/actionModules/incentivationTable/subtype/details/EvaluationThumbsSubtypeDetails";
import { EvaluationThumbsSubtypeDataModel } from "./evaluationThumbsSubtype";
import EvaluationThumbsSubtypeSummary from "../../../pages/incentivation/actionModules/incentivationTable/subtype/summary/EvaluationThumbsSubtypeSummary";

export const EvaluationThumbsSubtype: SubtypeDefinition = {
    name: "actionModules.subtypes.evaluationThumbs.name",
    type: Subtype.EvaluationThumbsModuleSubtype,
    icon: <ThumbUp />,
    toolboxPlaceholder: () => <SubtypeToolboxPlaceholderScaffold
        icon={<ThumbUp />}
        name="actionModules.subtypes.evaluationThumbs.name" />,
    editorPreview: () => {
        return <Stack
          sx={{justifyContent: "center", gap: 3}}
          direction="row"
        >
            <ThumbDown/><ThumbUp/>
        </Stack>;
    },
    subtypeDataView: (props) => <EvaluationThumbsSubtypeDetails
        subtype={props.subtype}
        subtypeData={props.subtypeData as EvaluationThumbsSubtypeDataModel} />,
    subtypeDataSummaryView: (props) => <EvaluationThumbsSubtypeSummary
        subtype={props.subtype}
        subtypeData={props.subtypeData as EvaluationThumbsSubtypeDataModel} />,
    editableProperties: []
};